export default "__VITE_ASSET__B7Iqfdo4__"